import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "image"
};
const _hoisted_2 = {
  class: "action"
};
const _hoisted_3 = {
  key: 1,
  class: "item"
};
const _hoisted_4 = {
  class: "icon"
};
const _hoisted_5 = {
  class: "body"
};
const _hoisted_6 = {
  class: "title"
};
const _hoisted_7 = {
  class: "info"
};
const _hoisted_8 = {
  class: "action"
};
import { ref } from "vue";
import { CircleCloseFilled } from "@element-plus/icons-vue";
import { isImage, removeArrayItem, substr } from "@/utils/libs";
import { FormatFileSize, GetFileIcon, GetFileType } from "@/store/system";
export default {
  __name: 'FileList',
  props: {
    files: {
      type: Array,
      default: []
    }
  },
  emits: ["removeFile"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    const fileList = ref(props.files);
    const removeFile = file => {
      fileList.value = removeArrayItem(fileList.value, file, (v1, v2) => v1.url === v2.url);
      emits("removeFile", file);
    };
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_link = _resolveComponent("el-link");
      const _component_el_container = _resolveComponent("el-container");
      return _openBlock(), _createBlock(_component_el_container, {
        class: "chat-file-list"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fileList.value, file => {
          return _openBlock(), _createElementBlock("div", {
            key: file.url
          }, [_unref(isImage)(file.ext) ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_image, {
            src: file.url,
            fit: "cover"
          }, null, 8, ["src"]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_icon, {
            onClick: $event => removeFile(file)
          }, {
            default: _withCtx(() => [_createVNode(_unref(CircleCloseFilled))]),
            _: 2
          }, 1032, ["onClick"])])])) : (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_image, {
            src: _unref(GetFileIcon)(file.ext),
            fit: "cover"
          }, null, 8, ["src"])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_el_link, {
            href: file.url,
            target: "_blank",
            style: {
              "--el-font-weight-primary": "bold"
            }
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(substr)(file.name, 30)), 1)]),
            _: 2
          }, 1032, ["href"])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("span", null, _toDisplayString(_unref(GetFileType)(file.ext)), 1), _createElementVNode("span", null, _toDisplayString(_unref(FormatFileSize)(file.size)), 1)])]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_icon, {
            onClick: $event => removeFile(file)
          }, {
            default: _withCtx(() => [_createVNode(_unref(CircleCloseFilled))]),
            _: 2
          }, 1032, ["onClick"])])]))]);
        }), 128))]),
        _: 1
      });
    };
  }
};